import { get, post } from './httpClient'

export const getAppSetting = () => get('/appsetting')
export const updateAppSetting = (body) => post('/appsetting/update', body)
export const getAllowedExtensions = () => get('/appsetting/allowed-extensions')
